import { Observable } from 'rxjs'
import { EventObject, Interpreter, State, StateSchema, Typestate } from 'xstate'

/** Adapt Interpreter from XState to RxJS */
export const fromInterpreter = <
  TContext,
  TStateSchema extends StateSchema,
  TEvent extends EventObject,
  TTypeState extends Typestate<TContext>,
  TResolvedTypes,
>(
  service: Interpreter<TContext, TStateSchema, TEvent, TTypeState, TResolvedTypes>,
): Observable<State<TContext, TEvent, TStateSchema, TTypeState, TResolvedTypes>> =>
  new Observable<State<TContext, TEvent, TStateSchema, TTypeState, TResolvedTypes>>((subscriber) =>
    service.subscribe(subscriber),
  )
